import { ChargePointIsMaintenance } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/charge-point/charge-point-is-maintenance.enum';
import { useTranslation } from 'react-i18next';

import { BooleanTriStateFilterController } from '@shared/filter/boolean-tri-state-filter/boolean-tri-state-filter.controller';

interface ChargePointIsMaintenanceFilterControllerProps {
  // null (not undefined) represents "All" — react-hook-form's Controller
  // falls back to its mount-time default whenever the live value is
  // undefined, so an explicit clear must never be undefined.
  onChange: (value: boolean | null) => void;
  selectedItem?: boolean | null;
}

const backgroundColorByState: Record<ChargePointIsMaintenance, string> = {
  [ChargePointIsMaintenance.TRUE]: 'bg-surface-error',
  [ChargePointIsMaintenance.FALSE]: 'bg-surface-success',
  [ChargePointIsMaintenance.ALL]: 'bg-surface-brand-secondary',
};

export const ChargePointIsMaintenanceFilterController = ({
  onChange,
  selectedItem,
}: ChargePointIsMaintenanceFilterControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // DATA FETCHING /////////////////////////////////////////////////////////////

  const options = Object.values(ChargePointIsMaintenance).map((state) => ({
    key: state,
    label: t(
      `delmonicos-shared-sdk.outputs-charge-point-is-maintenance.${state}`,
    ),
    value:
      state === ChargePointIsMaintenance.TRUE
        ? true
        : state === ChargePointIsMaintenance.FALSE
          ? false
          : null,
    colorClassName: backgroundColorByState[state],
  }));

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <BooleanTriStateFilterController
      iconName="terminal-maintenance"
      text={t('delmonicos-shared-sdk.outputs-charge-point.is-maintenance')}
      options={options}
      selectedItem={selectedItem}
      onChange={onChange}
    />
  );
};
